import {useContaCommand} from '@/commandbar/commandBar.service'
import TrialBalanceView from '@/tribal/TrialBalanceView.vue'
import {registerRoute} from '@/router'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import FatTribal from '@/tribal/FatTribal.vue'
import {getFeatureValue} from '@/feature-toggles/feature-toggler.service'

export const NEW_GENLEG_TRIBAL_FT_KEY = 'NEW_TRIBAL_GENLEG'
export const FAT_TRIBAL = {componentName: 'FatTribal', component: FatTribal, meta: {requiresOrg: true}}
registerRoute(FAT_TRIBAL)

export const TRIAL_BALANCE = {componentName: 'TrialBalance', component: getFeatureValue(NEW_GENLEG_TRIBAL_FT_KEY) ? FatTribal : TrialBalanceView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()
const icon = 'i-ph-scales-fill'
const label = 'Saldobalanse'
const hotkey = 'e'

registerNavigationCommand({
    route: TRIAL_BALANCE,
    label,
    icon,
    hotkey
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'trial-balance',
    icon,
    target: TRIAL_BALANCE,
    sortOrder: 6
})

registerRoute(TRIAL_BALANCE)
registerHotkey(hotkey, TRIAL_BALANCE)
buildSimpleCrumb(TRIAL_BALANCE, label, icon, true)

